module.exports = __webpack_public_path__ + "static/element_menu-fbbde94e3a5acbe5fc7ed1699d27b507.svg";